export const listenerDelay = 300;
export const navCellsCount = 2;
